export default __webpack_public_path__ + "d9b705f5351d98cce1e3204a028e3937.png";